import { ResetPasswordView } from '@/features/auth';
import { setPageTitle } from '@/lib/utils';

export function ResetPasswordPage() {
  setPageTitle('Reset Password');
  return <ResetPasswordView />;
}
